// extracted by mini-css-extract-plugin
export default {"table":"SimpleTable_table__KeeBV","tableStriped":"SimpleTable_tableStriped__R0jmH","active":"SimpleTable_active__DrIlO","tableHover":"SimpleTable_tableHover__G5geT"};